import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { BpTryAgainErrorComponent } from "./bp-try-again-error.component";

@NgModule({
	imports: [CoreModule],
	declarations: [BpTryAgainErrorComponent],
	exports: [BpTryAgainErrorComponent]
})
export class BpTryAgainErrorModule {}
